// extracted by mini-css-extract-plugin
export default {"disabled":"index__disabled__EMtiU","dragging":"index__dragging__1P6UB"};